_ = require 'underscore'
l = require 'app/scripts/lib/localize'
moment = require 'moment'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
template = require 'app/scripts/views/templates/plugin_date_picker'

getPikadayStrings = ->
  previousMonth: l('prev month button text')
  nextMonth: l('next month button text')
  months: moment.months()
  weekdays: moment.weekdays()
  weekdaysShort: moment.weekdaysMin()

timeFormat = 'LT'
parseFormat = [timeFormat, 'h:mm A']
isTimeStringValid = (string) -> moment(string, parseFormat).isValid()

module.exports = class PluginPopOverDateTimeView extends PluginView
  initialize: ({ @title, @content }) ->
    @retain(@content)
    @dateOnly = @content.type == 'date'
    @loadPikadayLibrary()

  loadPikadayLibrary: ->
    @pikadayLoadPromise ?= `import(/* webpackChunkName: "pikaday" */'pikaday')`
      .then((library) =>
        @Pikaday = library.default
      )

  getViewTitle: -> @title

  keepInDOM: true

  events: ->
    'click a[href]': (e) ->
      PopOver.hide()
    'input .js-dpicker-time-input': 'validateTimeInput'
    'change .js-dpicker-time-input': 'normalizeTimeInput'
    'click input.primary': (e) ->
      @pickDate(e)
    'submit': (e) ->
      e.preventDefault()
      @pickDate(e)

  getSelectedDateMoment: ->
    date = @picker.getMoment()
    if !date.isValid()
      return null

    # Pikaday requires a single date format, and will parse it strictly (which
    # is good). However, this means an entry like '2/14/15' will parse as
    # '02/14/0015', which isn't great.
    if date.year() < 1000
      date.add(2000, 'years')

    time = @selectedTimeMoment()
    date
    .hour time.hour()
    .minute time.minute()

  pickDate: (e) ->
    dateMoment = @getSelectedDateMoment()
    if _.isFunction(@content.callback)
      @content.callback({
        el: e.currentTarget
        options: {
          date: dateMoment?.toISOString()
        }
      }).catch (err) ->
        console?.warn "Error running Power-Up date picker callback function: #{err.message}"
      # Note: this MUST come after calling the callback, as this will release the callback
      Promise.delay(1).then(-> PopOver.popView())
    else
      PopOver.popView()

  vigor: @VIGOR.NONE
  renderOnce: ->
    tomorrowAtNoon = moment().startOf('day').add(1, 'days').hour(12).toDate()
    date = tomorrowAtNoon
    if _.isString(@content.date) && moment(@content.date).isValid()
      date = moment(@content.date).toDate()

    minDate = if _.isString(@content.minDate) && moment(@content.minDate).isValid() then moment(@content.minDate).toDate()
    maxDate = if _.isString(@content.maxDate) && moment(@content.maxDate).isValid() then moment(@content.maxDate).toDate()
    yearRange = 10 # default behavior of Pikaday
    if minDate || maxDate
      yearRange = [
        if minDate then minDate.getFullYear() else (new Date()).getFullYear() - 10,
        if maxDate then maxDate.getFullYear() else (new Date()).getFullYear() + 10,
      ]

    @$el.html(template({ dateOnly: @dateOnly }))

    @loadPikadayLibrary().then =>

      @picker = new @Pikaday
        field: _.first(@$('.js-dpicker-date-input'))
        container: _.first(@$('.js-dpicker-cal'))
        bound: false
        format: 'l'
        firstDay: moment.localeData().firstDayOfWeek()
        i18n: getPikadayStrings()
        keyboardInput: false
        minDate: minDate
        maxDate: maxDate
        yearRange: yearRange

      @picker.setDate(date)

      if !@dateOnly
        @$timeInput().val(moment(date).format(timeFormat))

    @

  validateTimeInput: ->
    @$timeInput().toggleClass('input-error', !@isTimeInputValid())

  normalizeTimeInput: ->
    @$timeInput().val @selectedTimeMoment().format(timeFormat)
    @validateTimeInput()

  selectedTimeMoment: ->
    if @dateOnly
      moment().hours(0).minutes(0)
    else if @isTimeInputValid()
      moment(@$timeInput().val(), parseFormat)
    else
      moment().hours(12).minutes(0)

  $timeInput: -> @$('.js-dpicker-time-input')

  isTimeInputValid: -> isTimeStringValid(@$timeInput().val())
